.ux-w-shopping-lists {
    display: block;

    &__slot-container {
        display: flex;
    }

    &__item {
        display: inline-flex;
        height: 100%;

        &:nth-of-type(even) {
            background: $color-blue-menu-bg;
        }
    }
}
